import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Blank } from 'src/app/shared/models/exercise.model';
import { CommunicationService } from 'src/app/shared/services/communication.service';
import { UtilityService } from 'src/app/shared/utils/utility.service';
// import { Blank } from 'src/app/models/exercise.model';
import { OptionSelectorService } from '../services/option-selector.service';
// import { CommunicationService } from '../../services/communication.service';
// import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-blanks',
  templateUrl: './blanks.component.html',
  styleUrls: ['./blanks.component.css']
})
export class BlanksComponent implements OnInit, OnChanges {
  map: { [key: string]: string } = {};
  textline: string = '';
  field: string = '#blank#';
  texts: string[];
  value: string[] = [];
  corrects: boolean[] = [];
  _element: Blank
  _answer: any;
  width: { [key: number]: string } = {};
  filledQuestion: number = 0;
  copyAllOptions: string[];
  questionChecked: boolean = false;
  @Input() fixedEditor: any;
  @Input() set element(element) {
    this._element = element;
    // console.log(this._element, 'this._elementthis._elementthis._element')
    this.textline = this._element.question;
    this.configureQuestion();
    this.corrects = Array(this._element.options.length).fill(false);
    this.value = Array(this._element.options.length).fill('');
    if (this._element.type == 'DRAGGABLE') {
      this.setOptions();
    }
  }
  @Input()
  set answer(answer) {
    this._answer = answer;
    if(this._answer){
      this.questionChecked = true;
      this.map = JSON.parse(this._answer);
    }
    this.updateCorrectAnswers();
  }
  @Input() index: any;
  @Input() exerciseTimetrackingdata;
  
  @Input() correctAnswers;
  @Input() isResultPublished: boolean = false;
  @Input() points: any;
 
  @Input() variableFeedback: any;
  @Input() id: string;
  @Input() exerciseId: string;
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Input() isSubmitted: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;
  @Output() valueChanged = new EventEmitter();
  @Output() onReview = new EventEmitter();
  @Output() back = new EventEmitter<Boolean>(false);
  @Input() questionBlos;

  constructor(private optionSelectorService: OptionSelectorService, private utilitiyService: UtilityService, private communicationService: CommunicationService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: any) {
    if(changes.correctAnswers){
      this.updateCorrectAnswers(changes.correctAnswers.currentValue);
    }
    if(changes.immediateFeedBackRequired){
      this.updateCorrectAnswers(null,changes.immediateFeedBackRequired.currentValue);
    }
  }

  updateCorrectAnswers(correctAnswers?: any,immediateFeedBackRequired?:boolean): any {  
    for (let o in this.map) {
      let i = this._element && this._element.options.findIndex((i) => i._id == o);

      console.log(i, 'this.mapthis.mapthis.map')
      if (i > -1) {
        this.value[i] = this.map[o];
        this.width[i] = (this.map[o].length + 1) * 9 + 'px';
        if (correctAnswers && correctAnswers.length && Object.keys(correctAnswers).some(k => correctAnswers[k])) {
          this.corrects[i] = correctAnswers.includes(o);
        }
      }
    }
    if(this._answer && immediateFeedBackRequired && !this.isSubmitted){
      this.check();
    }
  }

  configureQuestion() {
    let regex = null;
    regex = new RegExp(this.field, 'gi');
    this.texts = this.textline.split(regex);
  }

  focusout(index) {
    this.map[this._element.options[index]._id] = this.value[index];
  }

  backHandler() {
    this.back.emit(true);
  }

  resize(value) {
    if (value) {
      if (((value.length + 1) * 9) <= 70)
        return '200px';
      else if (((value.length + 1) * 9) > 400)
        return '100%';
      else
        return (((value.length + 1) * 9) + 30) + 'px';
    } else
      return '200px'
  }

  next() {
    this.valueChanged.emit({ elementId: this.id, answer: JSON.stringify(this.map) });
  }

  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  get showNextButton() {
    return this.value.length && this.value.every(el => el.length > 0);
  }

  setOptions() {
    this.copyAllOptions = Array.from(this._element.allOptionsToDisplay);
    this.copyAllOptions = this.shuffle(this.copyAllOptions);
  }


  get questionAttempted() {
    let arr = Object.keys(this.map);
    return arr.length == this._element.options.length && arr.every(el => (this.map[el].length > 0));
  }

  check() {
    let data = [];
    this._element.options.forEach(o => {
      let item = { answer: this.map[o._id], type: this._element.type }
      if (o.blankOptions.length) {
        item['blankOptions'] = o.blankOptions
      } else {
        item['text'] = o.text
      }
      data.push(item)
    })

    let obj = { elementId: this.id, answer: JSON.stringify(this.map) }
    this.utilitiyService.evaluateQuestion({exerciseId:this.exerciseId,answers:obj}).subscribe(data=>{
      if(data){
        this.variableFeedback = data.answerFeedback
        this.questionChecked = true; 
        this.onReview.emit(obj);
      }
    });

    this.utilitiyService.checkAnswers(data).subscribe(res => {
      this.corrects = [];
      res.forEach((element, i) => {
        this.corrects[i] = res[i].isCorrect;
      });
    })
  }
  skip() {
    this.valueChanged.emit({ elementId: this.id, answer: '' });
  }

  _reportFeedback(value) {
    this.reportFeedback.emit(value);
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }
}
